import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SectionTitle } from "../styles/SectionTitle";
import IconNavArrowRight from "./icons/IconNavArrowRight";
import IconNavArrowDown from "./icons/IconNavArrowDown";

interface CollapsibleSectionProps {
	title: string;
	children: React.ReactNode;
}

export function CollapsibleSection({
	title,
	children,
}: CollapsibleSectionProps) {
	const [isOpen, setIsOpen] = useState(true);
	const toggleOpen = () => setIsOpen(!isOpen);

	return (
		<div>
			<div
				onClick={toggleOpen}
				style={{
					display: "flex",
					alignItems: "center",
					cursor: "pointer",
					color: "#fff",
				}}
			>
				{isOpen ? <IconNavArrowDown /> : <IconNavArrowRight />}
				<SectionTitle title={title}></SectionTitle>
			</div>
			<AnimatePresence initial={false}>
				{isOpen && (
					<motion.section
						key="content"
						initial="collapsed"
						animate="open"
						exit="collapsed"
						variants={{
							open: { opacity: 1, height: "auto" },
							collapsed: { opacity: 0, height: 0 },
						}}
						transition={{ duration: 0.2 }}
					>
						{children}
					</motion.section>
				)}
			</AnimatePresence>
		</div>
	);
}
